module.exports = __webpack_public_path__ + "static/media/icon-how-it-works6.f9584703.svg";